const releases = [
  {
    title: 'NULLHERTZ — Acid Devine',
    label: 'FE CHROME',
    date: 'October 2025',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/68fabd62-926d-4676-ad85-507effd5bf7a_e9733a3f-34eb-409a-a3bd-cfdd3b68db12.webp?v=1201e20e1e7524300c78d7d5f6b4ab15',
    achievement: 'Peaktime Techno powerhouse release',
    genre: 'Peaktime Techno',
    featured: true,
    link: 'https://www.beatport.com/de/track/acid-devine/22006740',
  },
  {
    title: 'Lyah Noir, A*S*Y*S — The Greatest',
    label: 'CHROME RED',
    date: 'July 2025',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/af0cbea2-6ab5-45ad-9869-8fbd37597736_artworks-4m0QswtQz0bVqWFI-VECcdg-t500x500-1420219643.jpg?v=dd783b782aa77cdc554cca44c043cd44',
    achievement: 'Electro / Techno collaboration',
    genre: 'Techno',
    featured: false,
    link: 'https://www.beatport.com/de/track/the-greatest/20653639',
  },
  {
    title: 'Morees — Techno Music',
    label: 'ANIMARUM BLACK',
    date: 'March 2025',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/f7326ff4-785a-4969-b3d8-d9845d924d3e_Techno-Music.webp?v=b594864f84edc7ff0ef294e2da778d61',
    achievement: 'Melodic Techno standout',
    genre: 'Melodic Techno',
    featured: false,
    link: 'https://www.beatport.com/de/track/techno-music/20086864',
  },
  {
    title: 'Morees — Techno Heart',
    label: 'ERROR AUDIO',
    date: 'February 2025',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/182a1944-80bf-44df-b41d-e5890b5d7c32_Techno-Heart.webp?v=c60bc8c325ac2193a46466cd2866a2cc',
    achievement: 'Dark melodic techno cut',
    genre: 'Melodic Techno',
    featured: false,
    link: 'https://www.beatport.com/de/track/techno-heart/20084112',
  },
  {
    title: 'Captain Jack — Long Long Time Ago',
    label: 'CAPTAIN JACK',
    date: 'February 2024',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/8883a402-d8ab-4a69-81a2-0ef6ed8383ec_Captain-Jack-Long-Long-Time-Ago-300x300.jpg?v=61dcdcf5f710583cd21023d27d017f63',
    achievement: 'Eurodance classic reborn',
    genre: 'Eurodance',
    featured: false,
    link: 'https://music.youtube.com/watch?v=TavnmjX7pE4&list=OLAK5uy_mNqGjPCpYnmPN-LPSW30qTLGnsZDxhxGw',
  },
  {
    title: 'MEELA DJ — Magic Music',
    label: 'STEREO POEMS',
    date: 'March 2023',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/a5da2c3b-76e1-4c57-8646-3f7daae80a1c_Magic-Music.webp?v=dfc394c2e01908154369909e2d68d320',
    achievement: 'Electronic dance anthem',
    genre: 'Electronic / Dance',
    featured: false,
    link: 'https://www.beatport.com/de/track/magic-music/18031175',
  },
];

export default function CaseStudy() {
  const featured = releases[0];
  const rest = releases.slice(1);

  return (
    <section id="releases" className="relative py-32 overflow-hidden">
      {/* Background image — full bleed edge to edge */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/c7480aeb-0a27-4f17-b1ec-8ca805e9a133_ChatGPT-Image-23.-Apr.-2026-21_48_47.png?v=49eacf2a3a81a9501f012b309fb1c7d0"
          alt=""
          className="w-full h-full object-cover object-right-top"
        />
        <div className="absolute inset-0 bg-[#0a0a0a]/60" />
        {/* Top & bottom fade to black */}
        <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-black to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-px bg-white/30" />
          <span className="text-white/40 text-xs font-medium tracking-[0.3em] uppercase">Discography</span>
        </div>
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6 mb-16">
          <h2 className="text-white font-bold leading-tight" style={{fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.02em'}}>
            Latest Releases
          </h2>
          <p className="text-white/50 text-sm max-w-sm leading-relaxed lg:text-right">
            Chart-toppers, underground bangers, and timeless remixes — forged in the creative vault of AceAge-Music.
          </p>
        </div>

        {/* Featured Release */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          <a href={featured.link} target="_blank" rel="noopener noreferrer" className="relative overflow-hidden rounded-lg group aspect-square block">
            <img
              src={featured.image}
              alt={featured.title}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute top-4 left-4">
              <span className="bg-white text-black text-xs font-bold px-3 py-1 rounded-full tracking-wider uppercase">Featured</span>
            </div>
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <span className="bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-medium px-4 py-2 rounded-full tracking-widest uppercase">Listen Now</span>
            </div>
          </a>
          <div className="flex flex-col justify-center">
            <span className="text-white/30 text-xs tracking-widest uppercase mb-3">{featured.label} · {featured.date}</span>
            <h3 className="text-white font-bold text-3xl mb-4" style={{fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.02em'}}>{featured.title}</h3>
            <p className="text-white/60 text-sm mb-4">{featured.achievement}</p>
            <div className="flex items-center gap-3 mb-8">
              <span className="border border-white/20 text-white/50 text-xs px-3 py-1 rounded-full">{featured.genre}</span>
            </div>
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-4 text-white/40 text-sm">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-album-line text-lg" />
                  </div>
                  <span>Fe Chrome 047</span>
                </div>
              </div>
              <div className="h-px bg-white/10" />
              <p className="text-white/40 text-xs leading-relaxed">
                "Acid Devine" by NULLHERTZ blends driving techno energy with sharp acid elements and a dark, hypnotic flow. The track feels raw and direct while building a tense, atmospheric momentum on the dancefloor.
              </p>
            </div>
          </div>
        </div>

        {/* Rest of releases */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {rest.map((release, i) => (
            <a key={i} href={release.link} target="_blank" rel="noopener noreferrer" className="group cursor-pointer block">
              <div className="aspect-square overflow-hidden rounded-lg mb-3 relative">
                <img
                  src={release.image}
                  alt={release.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/30">
                  <span className="bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-medium px-3 py-1.5 rounded-full tracking-widest uppercase whitespace-nowrap">Listen Now</span>
                </div>
              </div>
              <div>
                <span className="text-white/30 text-xs tracking-widest uppercase block mb-1">{release.label}</span>
                <h4 className="text-white/80 group-hover:text-white text-sm font-medium leading-snug transition-colors line-clamp-2">{release.title}</h4>
                <p className="text-white/30 text-xs mt-1">{release.date}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
